import {Component, inject, signal} from '@angular/core';
import {Router} from '@angular/router';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {TrimValidator} from '../../../utils/validators';
import {BorService} from '../../../sdk/bor-api';
import {ToastrService} from '../../../shared/services/toast/toastr.service';
import {finalize} from 'rxjs';

@Component({
  selector: 'bor-home',
  standalone: false,
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  host: { class: 'home-sections' }
})
export class HomeComponent {
  searchTerm!: string;

  hasError = false;

  router = inject(Router);


  onSearch(){
    this.hasError = false;
    this.searchTerm = this.searchTerm?.trim() || '';

    if(this.searchTerm === ''){
      this.hasError = true;
      return;
    }

    this.router.navigateByUrl('/search/results?q=' + this.searchTerm);
  }
}
